<arpio-center-panel>
  <h3 class="panel-title">Page not found</h3>
  <div class="margin-top">The page you're looking for doesn't exist or may have been moved.</div>
  <div class="margin-top actions">
    <button class="primary-button" (click)="goHome()">
      <svg lucideArrowLeft></svg>
      Back to Home
    </button>
  </div>
  <div class="margin-top help-text">If you followed a link to get here, please contact support so we can fix it.</div>
</arpio-center-panel>
